/* eslint-disable indent */
/**
 * Swiper 7.0.6
 * @url : https://swiperjs.com/api/
 */
// import Swiper JS
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Keyboard, FreeMode, Mousewheel, A11y } from 'swiper';


// Load Swiper with Drupal BigPipe Support
(function ($, Drupal) {
  const a11y = {
    prevSlideMessage: 'Diapositive précédente',
    nextSlideMessage: 'Diapositive suivante',
    firstSlideMessage: 'Ceci est la première diapositive',
    lastSlideMessage: 'Ceci est la dernière diapositive',
    paginationBulletMessage: 'Allez vers la diapositive {{index}}'
  }

  Drupal.behaviors.LoadSwiper = {
    /**
     * Attach js function
     * @param {HTMLElement} context Context Element
     * @param {Object} settings Settings object
     */
    attach: function (context, settings) {
      const swipersNews = Array.from(context.getElementsByClassName('js-swiper-news'));
      if (swipersNews.length) {
        for (const swiper of swipersNews) {
          // Swiper instance
          const swiperInstance = new Swiper(swiper, {
            modules: [Navigation, Pagination, Keyboard, A11y],
            slidesPerView: 1,
            loop: false,
            speed: 700,
            spaceBetween: 30,
            pagination: {
              el: ".swiper-pagination",
              dynamicBullets: false,
            },
            navigation: {
              nextEl: swiper.parentNode.querySelector('.swiper-button-next'),
              prevEl: swiper.parentNode.querySelector('.swiper-button-prev'),
            },
            init: false,
            breakpoints: {
              768: {
                slidesPerView: 2
              },
              1024: {
                slidesPerView: 3
              }
            },
            a11y
          })

          // Init only if there is 2 or more slides
          const nbSlides = swiper.getElementsByClassName('swiper-slide');
          if (nbSlides.length > 1) {
            swiperInstance.init();
          }
        }
      }

      const swipersAnchors = Array.from(context.getElementsByClassName('js-swiper-anchors'));
      if (swipersAnchors.length) {
        for (const swiper of swipersAnchors) {
          // Swiper instance
          const swiperInstance = new Swiper(swiper, {
            modules: [Keyboard, FreeMode, Mousewheel, A11y],
            slidesPerView: 'auto',
            freeMode: true,
            mousewheel: true,
            init: false,
            a11y
          })

          // Init only if there is 2 or more slides
          const nbSlides = swiper.getElementsByClassName('swiper-slide');
          if (nbSlides.length > 1) {
            swiperInstance.init();
          }
        }
      }

      const swipersRss = Array.from(context.getElementsByClassName('js-swiper-rss'));
      if (swipersRss.length) {
        for (const swiper of swipersRss) {
          // Swiper instance
          const swiperInstance = new Swiper(swiper, {
            modules: [Navigation, Keyboard, A11y],
            slidesPerView: 1,
            loop: false,
            speed: 700,
            spaceBetween: 30,
            navigation: {
              nextEl: swiper.parentNode.querySelector('.swiper-button-next'),
              prevEl: swiper.parentNode.querySelector('.swiper-button-prev'),
            },
            init: false,
            breakpoints: {
              768: {
                slidesPerView: 2
              },
              1024: {
                slidesPerView: 4
              }
            },
            a11y
          })

          // Init only if there is 2 or more slides
          const nbSlides = swiper.getElementsByClassName('swiper-slide');
          if (nbSlides.length > 1) {
            swiperInstance.init();
          }
        }
      }
    }
  }
})(jQuery, Drupal);


